import loadable from '@loadable/component';

import * as api from '../server/api'
// constants
import redirectHandlers from './lib/constants/redirectHandlers';
import RedirectToPath from './components/Reusable/RedirectToPath';

const Home = loadable(() => import(/* webpackChunkName: "Home" */ './components/Home/Home'));
const LoginPage = loadable(() => import(/* webpackChunkName: "LoginPage" */ './pages/login/LoginPage.js'));

// directories
const Startup = loadable(
    () => import(/* webpackChunkName: "Startup" */ './pages/directories/Startup.js')
);
const Company = loadable(
    () => import(/* webpackChunkName: "Company" */ './pages/directories/company/Company.js')
);
const ClientDirectory = loadable(
    () => import(/* webpackChunkName: "ClientDirectory" */ './pages/directories/clientDirectory/ClientDirectory.js')
);
const Ecosystem = loadable(
    () => import(/* webpackChunkName: "Ecosystem" */ './pages/directories/Ecosystem.js')
);
// the investor directory under test (/investors-and-funds), apart from the live one
const Investors = loadable(
    () => import(/* webpackChunkName: "Investors" */ './pages/directories/investors/Investors.js')
);
// the LP directory (/limited-partners): LPs and their commitments to funds
const Lps = loadable(
    () => import(/* webpackChunkName: "Lps" */ './pages/directories/lps/Lps.js')
);
const LimitedPartnersTracker = loadable(
    () => import(/* webpackChunkName: "LimitedPartnersTracker" */ './pages/directories/LimitedPartnersTracker.js')
);
const PrivateEquityLanding = loadable(
    () => import(/* webpackChunkName: "PrivateEquityLanding" */ '/src/pages/landingPages/PrivateEquityLanding.js')
);

const PrivateEquityDirectory = loadable(
    () => import(/* webpackChunkName: "PrivateEquityDirectory" */ '/src/pages/directories/PrivateEquity.js')
);

const DirectoryLanding = loadable(
    () => import(/* webpackChunkName: "DirectoryLanding" */ './pages/landingPages/directoryLanding/DirectoryLanding.js')
);

const StartupsDirectoryLanding = loadable(
    () => import(/* webpackChunkName: "StartupsDirectoryLanding" */ './pages/landingPages/directoryLanding/StartupsDirectoryLanding.js')
);

const InvestorsDirectoryLanding = loadable(
    () => import(/* webpackChunkName: "InvestorsDirectoryLanding" */ './pages/landingPages/directoryLanding/InvestorsDirectoryLanding.js')
);

const FundsDirectoryLanding = loadable(
    () => import(/* webpackChunkName: "FundsDirectoryLanding" */ './pages/landingPages/directoryLanding/FundsDirectoryLanding.js')
);

const Newsletters = loadable(() => import(/* webpackChunkName: "Newsletters" */ '../src/components/Pages/Newsletters'));
const PricingPage = loadable(() => import(/* webpackChunkName: "PricingPage" */ '../src/components/Purchase/PricingPage'));
const Preferences = loadable(() => import(/* webpackChunkName: "Preferences" */ '../src/components/Pages/Preferences'));

const FAQ = loadable(() => import(/* webpackChunkName: "FAQ" */ '../src/components/Pages/FAQ'));
const AccountSettings = loadable(() => import(/* webpackChunkName: "AccountSettings" */ '../src/components/Pages/AccountSettings'));
const AboutUs = loadable(() => import(/* webpackChunkName: "AboutUs" */ '/src/pages/about/AboutUs'));
const TermsofService = loadable(() => import(/* webpackChunkName: "TermsofService" */ '../src/components/Pages/TermsofService'));
const TermsofResearch = loadable(() => import(/* webpackChunkName: "TermsofResearch" */ '../src/components/Pages/TermsofResearch'));
const AnalystHoursUsagePolicy = loadable(() => import(/* webpackChunkName: "AnalystHoursUsagePolicy" */ '../src/components/Pages/AnalystHoursUsagePolicy.js'));
const PrivacyandCookies = loadable(() => import(/* webpackChunkName: "PrivacyandCookies" */ '../src/components/Pages/PrivacyandCookies'));
const ContactUs = loadable(() => import(/* webpackChunkName: "ContactUs" */ '../src/components/Pages/ContactUs'));

// single sice
const StartupPage = loadable(
    () => import(/* webpackChunkName: "StartupPage" */ '/src/components/SingleSICE/StartupPage'));
const ICEPage = loadable(
    () => import(/* webpackChunkName: "ICEPage" */ '/src/components/SingleSICE/ICEPage'));


const SingleJob = loadable(() => import(/* webpackChunkName: "SingleJob" */ '/src/components/Careers/SingleJobs'));

const VerifyEmailSuccess = loadable(() => import(/* webpackChunkName: "VerifyEmailSuccess" */ '../src/components/Pages/VerifyEmailSuccess'));
const DownloadSuccess = loadable(() => import(/* webpackChunkName: "DownloadSuccess" */ '../src/components/Pages/DownloadSuccess'));
const SavedSearchDashBoard = loadable(() => import(/* webpackChunkName: "SavedSearchDashBoard" */ './pages/savedSearchDashBoard/SavedSearchDashBoard'));

const RedirectionPage = loadable(() => import(/* webpackChunkName: "RedirectionPage" */ './pages/RedirectionPage'));
const ThankYouPage = loadable(() => import(/* webpackChunkName: "ThankYouPage" */ './pages/ThankYouPage'));

// Advanced Analytics Dashboards
const AdvancedAnalyticsDashboard = loadable(() => import(/* webpackChunkName: "AdvancedAnalyticsDashboard" */ './pages/advancedAnalytics/AdvancedAnalyticsPage'));
const StartupAnalyticsPage = loadable(() => import(/* webpackChunkName: "StartupAnalyticsPage" */ './pages/advancedAnalytics/StartupAnalyticsPage'));
const MarketSizingPage = loadable(() => import(/* webpackChunkName: "MarketSizingPage" */ './pages/advancedAnalytics/MarketSizingPage'));
const DealSizeAnalysisPage = loadable(() => import(/* webpackChunkName: "DealSizeAnalysisPage" */ './pages/advancedAnalytics/DealSizeAnalysisPage'));
const GeoBenchmarkPage = loadable(() => import(/* webpackChunkName: "GeoBenchmarkPage" */ './pages/advancedAnalytics/GeoBenchmarkPage'));
const IndustryBenchmarkPage = loadable(() => import(/* webpackChunkName: "IndustryBenchmarkPage" */ './pages/advancedAnalytics/IndustryBenchmarkPage'));
const InvestorRankingPage = loadable(() => import(/* webpackChunkName: "InvestorRankingPage" */ './pages/advancedAnalytics/InvestorRankingPage'));
const ExitAnalysisPage = loadable(() => import(/* webpackChunkName: "ExitAnalysisPage" */ './pages/advancedAnalytics/ExitAnalysisPage'));

// Dynamic Custom Analytics Dashboards
const CustomAnalyticsPage = loadable(() => import(/* webpackChunkName: "CustomAnalyticsPage" */ './pages/advancedAnalytics/CustomAnalyticsPage'));

import { Jobs } from '/src/components/Careers/Jobs';
import { Internships } from '/src/components/Careers/Internships';
import NoMatch from './MicroFrontends/NoMatch';
import FeatureUnavailable from './MicroFrontends/FeatureUnavailable';

const DemoRequestForm = loadable(
    () => import(/* webpackChunkName: "DemoRequestForm" */ './pages/contactSales/DemoRequestForm')
);

// typeforms
const AfricaNewsletterForm = loadable(() => import(/* webpackChunkName: "AfricaNewsletterForm" */ './pages/forms/AfricaNewsletterForm'));

// import routes from other files
import { dataLandingPageRoutes } from './lib/routeConstants/dataLandingPageRoutes.js';

// set ssr helmet data for components where the title can vary based on the route
const helmetSubscribe = {
    title: 'Subscribe | MAGNiTT',
    metaContent: 'MAGNiTT has a subscription offering that provides access to data, research and analytics on the Middle East, Africa, Turkey and Pakistan venture funding ecosystem. Access to reports, interactive dashboards and exports to CSV.',
    ogTitle: 'Subscribe to MAGNiTT'
}

const helmetBuyReport = {
    title: 'Purchase Report | MAGNiTT',
    metaContent: 'Empower your team with data-driven research and insights on the tech ecosystem, as referenced by TechCrunch, Bloomberg and the FT',
    ogTitle: 'Purchase Report'
}

// set routes

const routes = [
    {
        path: "/",
        exact: true,
        component: Home
    },
    {
        path: "/startups",
        exact: true,
        component: Startup,
        getRedirectComponent: (userData) =>
            redirectHandlers.Startup(userData, StartupsDirectoryLanding)
    },
    {
        path: "/companies",
        exact: true,
        component: Company,
        getRedirectComponent: (userData) =>
            redirectHandlers.Company(userData, StartupsDirectoryLanding)
    },
    {
        path: "/client-directory",
        exact: true,
        component: ClientDirectory,
        getRedirectPath: redirectHandlers.ClientDirectory
    },
    {
        path: "/en-:iso/startups",
        exact: true,
        component: Startup
    },
    {
        path: "/en-:iso/startups/:industry",
        exact: true,
        component: Startup
    },
    {
        path: "/investors",
        exact: true,
        component: Ecosystem,
        getRedirectComponent: (userData) =>
            redirectHandlers.Investor(userData, InvestorsDirectoryLanding)
    },
    {
        // one route for the page and its tabs (/investors-and-funds, /investors-and-funds/funds-view, ...): the page stays mounted when the tab changes
        path: "/investors-and-funds/:tab?",
        exact: true,
        component: Investors,
        redirectTo: "/investors",
        getRedirectPath: (userData) => redirectHandlers.InvestorDev(userData),
        getRedirectComponent: (userData) => redirectHandlers.InvestorDev(userData, RedirectToPath)
    },
    {
        // one route for the page and its tabs (/limited-partners, /limited-partners/lps-view, /limited-partners/commitments-view): the page stays mounted when the tab changes
        path: "/limited-partners/:tab?",
        exact: true,
        component: Lps,
        // admins only while under test, as /investors-and-funds: everyone else goes to /investors
        redirectTo: "/investors",
        getRedirectPath: (userData) => redirectHandlers.Lps(userData),
        getRedirectComponent: (userData) => redirectHandlers.Lps(userData, RedirectToPath)
    },
    {
        path: "/en-:iso/investors",
        exact: true,
        component: Ecosystem
    },
    {
        path: "/en-:iso/investors/:type",
        exact: true,
        component: Ecosystem
    },
    {
        path: "/dashboards",
        exact: true,
        component: SavedSearchDashBoard,
        getRedirectPath: redirectHandlers.SavedSearchDashBoard
    },
    {
        path: "/newsletters",
        exact: true,
        component: Newsletters,
        fetchInitialData: () => api.getPastNewsletters()
    },
    {
        path: "/preferences",
        exact: true,
        component: Preferences
    },
    {
        path: "/jobs",
        exact: true,
        component: Jobs
    },
    {
        path: "/internships",
        exact: true,
        component: Internships
    },
    {
        path: "/pricing",
        exact: true,
        component: PricingPage
    },
    {
        path: "/faq",
        exact: true,
        component: FAQ
    },
    {
        path: "/mysettings",
        exact: true,
        component: AccountSettings,
        getRedirectPath: redirectHandlers.AccountSettings
    },
    {
        path: "/aboutus",
        exact: true,
        component: AboutUs
    },
    {
        path: "/terms-and-conditions",
        exact: true,
        component: TermsofService
    },
    {
        path: "/analyst-hours-terms",
        exact: true,
        component: AnalystHoursUsagePolicy
    },
    {
        path: "/research-terms",
        exact: true,
        component: TermsofResearch
    },
    {
        path: "/privacy-policy",
        exact: true,
        component: PrivacyandCookies
    },
    {
        path: "/contactus",
        exact: true,
        component: ContactUs
    },
    {
        path: "/jobs/:slug",
        exact: true,
        component: SingleJob,
        fetchInitialData: (path, token, refreshToken) =>
            api.fetchJobDetails(path.split("/")[2], token, refreshToken)
    },
    {
        path: "/startups/:slug",
        exact: true,
        component: StartupPage,
        fetchInitialData: (path, token, refreshToken) =>
            api.fetchStartupDetails(path.split("/")[2], token, refreshToken)
    },

    {
        path: "/investors/:slug",
        exact: true,
        entityType: "investor",
        component: ICEPage,
        fetchInitialData: async (path, token, refreshToken) => {
            const slug = path.split("/")[2];
            const entityType = "investor";
            return await api.fetchICEDetails(
                slug,
                entityType,
                token,
                refreshToken
            );
        }
    },

    {
        path: "/corporates/:slug",
        exact: true,
        entityType: "corporate",
        component: ICEPage,
        fetchInitialData: async (path, token, refreshToken) => {
            const slug = path.split("/")[2];
            const entityType = "corporate";
            return await api.fetchICEDetails(
                slug,
                entityType,
                token,
                refreshToken
            );
        }
    },

    {
        path: "/enablers/:slug",
        exact: true,
        entityType: "enabler",
        component: ICEPage,
        fetchInitialData: async (path, token, refreshToken) => {
            const slug = path.split("/")[2];
            const entityType = "enabler";
            return await api.fetchICEDetails(
                slug,
                entityType,
                token,
                refreshToken
            );
        }
    },
    {
        path: "/login",
        exact: true,
        component: LoginPage
    },
    {
        path: "/download-success",
        component: DownloadSuccess
    },
    {
        path: "/verify-email-success",
        component: VerifyEmailSuccess
    },
    {
        path: "/not-found",
        exact: true,
        component: NoMatch
    },
    {
        path: "/feature-unavailable",
        exact: true,
        component: FeatureUnavailable
    },
    {
        path: "/funds",
        exact: true,
        component: LimitedPartnersTracker,
        getRedirectComponent: (userData) =>
            redirectHandlers.Funds(userData, FundsDirectoryLanding)
    },
    {
        path: "/africa-newsletter",
        exact: true,
        component: AfricaNewsletterForm
    },
    {
        path: "/newsletter-redirect",
        exact: true,
        component: RedirectionPage
    },
    {
        path: "/newsletter-success",
        exact: true,
        component: ThankYouPage
    },
    {
        path: "/demo-request",
        exact: true,
        component: DemoRequestForm
    },

    /* Advanced Analytics */
    {
        path: "/advanced-analytics",
        exact: true,
        component: AdvancedAnalyticsDashboard
    },
    {
        path: "/analytics/startup-analysis",
        component: StartupAnalyticsPage,
        getRedirectPath: redirectHandlers.StartupAnalyticsPage
    },
    {
        path: "/analytics/market-sizing",
        component: MarketSizingPage,
        getRedirectPath: redirectHandlers.MarketSizingPage
    },
    {
        path: "/analytics/deal-size",
        component: DealSizeAnalysisPage,
        getRedirectPath: redirectHandlers.DealSizeAnalysisPage
    },
    {
        path: "/analytics/geography",
        component: GeoBenchmarkPage,
        getRedirectPath: redirectHandlers.GeoBenchmarkPage
    },
    {
        path: "/analytics/industry",
        component: IndustryBenchmarkPage,
        getRedirectPath: redirectHandlers.IndustryBenchmarkPage
    },
    {
        path: "/analytics/investor-ranking",
        component: InvestorRankingPage,
        getRedirectPath: redirectHandlers.InvestorRankingPage
    },
    {
        path: "/analytics/exits",
        component: ExitAnalysisPage,
        getRedirectPath: redirectHandlers.ExitAnalysisPage
    },
    /* End -- Advanced Analytics */

    /* Dynamic Custom Analytics Dashboards */
    {
        path: "/analytics/:slug",
        exact: true,
        component: CustomAnalyticsPage,
        fetchInitialData: async (path, token, refreshToken, orgId) => {
            const slug = path.split("/")[2];
            return await api.fetchCustomAnalyticsPageDetails(
                slug,
                token,
                refreshToken,
                orgId
            );
        },
        getRedirectPath: redirectHandlers.CustomAnalyticsPage
    },
    /* End -- Dynamic Custom Analytics Dashboards */

    /* Private Equity */
    {
        path: "/private-equity",
        component: PrivateEquityDirectory,
        getRedirectComponent: (userData) =>
            redirectHandlers.PrivateEquityDirectory(
                userData,
                PrivateEquityLanding
            )
    },
    {
        path: "/directories",
        component: DirectoryLanding
    },

    /* End -- Private Equity */

    // add routes that were organized in other files for simplicity
    ...dataLandingPageRoutes
];

export default routes;
